export const RoundingMixin = {
  methods: {
    roundUp (n, d) {
      return Math.round(n * Math.pow(10, d)) / Math.pow(10, d)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/RoundingMixin.js